import { useMemo } from 'react';
import { useHotkeys } from 'react-hotkeys-hook';

export type UseFullscreenShortcutParams = {
  isFullscreen?: boolean;
  onExitFullscreen?: () => void;
  onOpenFullscreen?: () => void;
};

export function useFullscreenShortcut({
  isFullscreen,
  onExitFullscreen,
  onOpenFullscreen,
}: UseFullscreenShortcutParams) {
  const options = useMemo(
    () => ({ enabled: !!(onOpenFullscreen || onExitFullscreen), preventDefault: true }),
    [onOpenFullscreen, onExitFullscreen],
  );

  useHotkeys(
    // CMD+. , CMD+\, CTRL+. , CTRL+\
    'mod+period, mod+backslash',
    () => {
      isFullscreen ? onExitFullscreen?.() : onOpenFullscreen?.();
    },
    options,
    [isFullscreen, onExitFullscreen, onOpenFullscreen],
  );
}
